import { useEffect, useState } from "react";
import { ITrocPropositionResident } from "../../services/interfaces/ITrocResident2";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import { getTrocsPropositionsList } from "../../services/callAPI/trocsPropositions";
import TrocsPropositionsTable from "../../components/tables/TrocsPropositionsTable";

export function TrocPropositionsPage() {
  const [selectedOption, setSelectedOption] = useState<string>("TOUTES");

  const [isLoading, setIsLoading] = useState<boolean | null>(null);

  function handlePickUpSelectedOption(e: React.ChangeEvent<HTMLSelectElement>) {
    const selectedValue = e.target.value;

    setSelectedOption(selectedValue);
  }

  const [trocsPropositionsList, setTrocsPropositionsList] = useState<ITrocPropositionResident[] | null>(null);

  const [trigUseEffect, setTrigUseEffect] = useState<boolean>(false);

  const [errorOccurred, setErrorOccurred] = useState(false);

  useEffect(() => {

    const pickUpTrocsPropositions = async () => {
      try {
        setIsLoading(true); //start spinner

        //call API
        const response = await getTrocsPropositionsList();

        if (response.status === 204) {
          setIsLoading(false);

          //update setTrocsPropositionsList to null
          setTrocsPropositionsList(null);
        }
        else if (response.status === 200) {
          setIsLoading(false);

          setTrocsPropositionsList(response.data);
        }
        else {
          throw new Error("Erreur lors de la récupération des demandes de trocs");
        }

      }
      catch (error) {
        setIsLoading(false);
        //afficher un composant d'erreur au user
        setErrorOccurred(true);
      }
      finally {
        setIsLoading(false);
      }
    }

    pickUpTrocsPropositions();

  }, [trigUseEffect]);

  if (isLoading) {
    return <SpinnerC />
  }
  else if (trocsPropositionsList !== null && trocsPropositionsList?.length > 0) {
    return (
      <>
        <section className="flex flex-col gap-2 pb-24">

          <h1 className="text-greenCustom font-bold">Les propositions reçues</h1>

          <div className="flex justify-end">

            <label htmlFor="trocs-propositions"></label>

            <select id="trocs-propositions" name="dropdown" className="border-2 border-greenCustom rounded-md p-2 text-greenCustom cursor-pointer" onChange={handlePickUpSelectedOption}>
              <option value={"TOUTES"}>Toutes</option>
              <option value={"EN_ATTENTE"} >En attente</option>
              <option value={"ACCEPTEE"}>Acceptée</option>
              <option value={"EFFECTUEE"}>Effectué</option>
            </select>
          </div>

          {<TrocsPropositionsTable selectedOption={selectedOption} trocsPropositionsList={trocsPropositionsList} setTrigUseEffect={setTrigUseEffect} />}

        </section>
      </>
    )
  }
  else if (errorOccurred) {
    return <ErrorOccurred />
  }
  else {
    return (
      <div className="px-4 h-full flex items-center justify-center text-center">
        <p className="leading-loose">
          Tu n'as aucune proposition de troc pour le moment !<br />
          Commence par créer un élément d'échange à troquer. <br />
          Ensuite, aime les éléments d'échanges des nomades pour les inciter à échanger.
        </p>
      </div>
    )
  }
}